var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{attrs:{"maxlength":_vm.maxlength,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"isDetailChange":_vm.isDetailChange},on:{"change":_vm.change,"click":_vm.click}},[_vm._v(_vm._s(_vm.val))])}
var staticRenderFns = []

export { render, staticRenderFns }